import toMap from '~/misc/toMap';

export default toMap([
  'ALERT',
  'LIST_CHANGE_SELECTED',
  'LIST_CHANGE_SELECTED_ALL',
  'SET_ALL_ALERTS_START',
  'SET_ALL_ALERTS',
  'DELETE_ALERT',
  'INIT_ALERT_FORM',
  'ALERT_LOADS_LIST',
  'ALERT_LOADS_LIST_LOADING',
  'ALERT_ADD_FROM_OTHERWHERE'
]);



// WEBPACK FOOTER //
// ./src/modules/alert/types.js